import { Button } from "@shared/components/ui/Button";
import React, { FormEvent, useState } from "react";

interface SubTaskFormProps {
  onSubmit: (title: string) => Promise<void>;
  onCancel: () => void;
  initialTitle?: string;
  submitText?: string;
}

export const SubTaskForm: React.FC<SubTaskFormProps> = ({
  onSubmit,
  onCancel,
  initialTitle = "",
  submitText = "Add Subtask",
}) => {
  const [title, setTitle] = useState(initialTitle);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!title.trim()) return;

    setIsSubmitting(true);
    try {
      await onSubmit(title);
      if (!initialTitle) setTitle("");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <div>
          <label
            className="block text-sm font-medium mb-1"
            htmlFor="subtask-title"
          >
            Subtask Title
          </label>
          <input
            id="subtask-title"
            className="form-input w-full"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter subtask title"
            disabled={isSubmitting}
          />
        </div>
        <div className="flex justify-end space-x-2">
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Saving..." : submitText}
          </Button>
        </div>
      </div>
    </form>
  );
};
